import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import { flightSections } from "flights/flightSections";
import { Passengers } from "flights/passenger/Passengers";
import { useFlightDetail } from "flights/useFlightDetail";
import React from "react";
import { SidePanelLinkedShowList } from "../SidePanelLinkedShowList";
import { ButtonSecondary } from "components/Atoms/Button";
import { invalidateFlightsCache } from "utilities/api/flightQuery";
import { useQueryClient } from "@tanstack/react-query";

interface FlightSidePanelDetailsProps {
  flightSidePanelData: server.dto.FlightSidePanelData
  refetch: () => Promise<void>
}

export const FlightSidePanelDetails = (props: FlightSidePanelDetailsProps) => {
  const {
    state,
    onValueChanged,
    onSuccessfulUpdate,
    getUpdateFlightInstruction,
    refetchPassengers,
    isCreatingPassenger,
    setIsCreatingPassenger,
  } = useFlightDetail(
    props.flightSidePanelData.flight,
    props.flightSidePanelData.passengers,
    () => { },
    () => { },
    () => { },
    () => { },
  );

  const queryClient = useQueryClient();

  const onSuccessfulUpdateSidePanel = async (key: string, value: any) => {
    await onSuccessfulUpdate(key, value);
    invalidateFlightsCache(queryClient);
  }

  const sections = flightSections(props.flightSidePanelData.flight, state, getUpdateFlightInstruction);

  return <SidePanelDetailSectionTemplate
    isInPageEditable={props.flightSidePanelData.flight.permissions.canModify}
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={onSuccessfulUpdateSidePanel}
    fields={[
      ...sections,
      {
        key: "passengersLabel",
        label: "",
        hideLabel: true,
        render: () => <div className="flex">
          <h3 className="grow1">{RESX.Flight.Passengers}</h3>
          {props.flightSidePanelData.flight.permissions.canModify && <ButtonSecondary
            label={RESX.Buttons.btnNew}
            onClick={() => setIsCreatingPassenger(true)}
          />}
        </div>
      }, {
        key: "passengers",
        label: "",
        hideLabel: true,
        render: () => <Passengers
          isInPageEditable={props.flightSidePanelData.flight.permissions.canModify}
          isCreating={isCreatingPassenger}
          setIsCreating={setIsCreatingPassenger}
          isInSidePanel
          isPrivateJet={props.flightSidePanelData.flight.flightType === "private"}
          flightId={props.flightSidePanelData.flight.flightId}
          passengers={state.passengers}
          refetchPassengers={refetchPassengers}
        />
      }
    ]}
    additionalContent={<>
      <SidePanelLinkedShowList
        linkedShows={props.flightSidePanelData.linkedShows}
        linkShowToTravel={{
          canLink: props.flightSidePanelData.flight.permissions.canModify,
          travelType: "flight",
          travelId: props.flightSidePanelData.flight.flightId,
          appointmentDateTime: props.flightSidePanelData.flight.dateTime,
          artist: props.flightSidePanelData.flight.artist,
          linkedShowIds: props.flightSidePanelData.linkedShows.map(show => show.showId),
          onLinked: props.refetch
        }}
      />
    </>}
  />
}
